import { useState, useEffect, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'

import Column from 'components/Column'
import Row from 'components/Row'
import Spacer from 'components/Spacer'
import NumberSelector from 'components/NumberSelector'
import { maskValue } from 'utils/helpers'
import Button from 'components/Button'
import { setData } from 'store/reducers/info'

export default function ModalDatabases({ values, onBuy, onClose }) {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const initialValues = useMemo(() => {
    return {
      databases: 1,
      databasesValue: 0,
      hours: values.database.package_hours,
      hoursValue: 0,
      totalValue: values.database.value,
      type: 'databases',
      plan: '',
    }
  }, [values])

  useEffect(() => {
    dispatch(setData(initialValues))
  }, [dispatch, initialValues])

  const [selection, setSelection] = useState(initialValues)

  function handleChangeDatabase(value) {
    const dbPrice = value * values.database.additional
    const newSelection = {
      ...selection,
      databases: 1 + value,
      databasesValue: dbPrice,
    }
    calcTotalPrice(newSelection)
  }

  function handleChangeHours(value) {
    const hourPrice = value * values.hourly.additional
    const newSelection = {
      ...selection,
      hours: values.database.package_hours + value,
      hoursValue: hourPrice,
    }
    calcTotalPrice(newSelection)
  }

  function calcTotalPrice(selection) {
    const total = selection.databasesValue + selection.hoursValue
    selection.totalValue = total + values.database.value
    setSelection(selection)
  }

  function handleBuy() {
    const newSelection = {
      ...selection,
      plan: t('home.database.modal.footer', {
        databases: selection.databases,
        hours: selection.hours,
      }),
      price: t('home.database.modal.footer_price', {
        total: maskValue(selection.totalValue),
      }),
    }
    onBuy(newSelection)
  }

  return (
    <>
      <Spacer height={50} />
      <Column>
        <Row justify="center">
          <p className="description">
            {t('home.database.modal.initial', {
              hours: values.database.package_hours,
            })}
          </p>
        </Row>
        <Spacer height={10} />
        <p className="price">{maskValue(values.database.value)}</p>
        <Spacer height={20} />

        <Column align="center">
          <div className="right description">
            <Row align="center" justify="end">
              <NumberSelector onChange={handleChangeDatabase} />
              <Spacer width={10} />
              {t('home.database.modal.additional')}
            </Row>
          </div>
          <Spacer height={10} />
          <p className="left price">{maskValue(selection.databasesValue)}</p>
        </Column>
        <Spacer height={20} />

        <Column align="center">
          <div className="right description">
            <Row align="center" justify="end">
              <NumberSelector onChange={handleChangeHours} />
              <Spacer width={10} />
              {t('home.hourly.table.additional_hours')}
            </Row>
          </div>
          <Spacer height={10} />
          <p className="left price">{maskValue(selection.hoursValue)}</p>
        </Column>
        <Spacer height={20} />

        <Row align="center">
          <p className="left price total">
            {maskValue(selection.totalValue)}/{t('month')}
          </p>
        </Row>
      </Column>
      <Spacer height={40} />
      <p className="footer">
        {t('home.database.modal.footer', {
          databases: selection.databases,
          hours: selection.hours,
        })}
      </p>
      <p className="footer_price">
        {t('home.database.modal.footer_price', {
          total: maskValue(selection.totalValue),
        })}
      </p>

      <Spacer height={30} />
      <Row>
        <Button onClick={onClose} label={t('button.cancel')} />
        <Spacer width={30} />
        <Button
          onClick={handleBuy}
          className="primary"
          label={t('button.buy')}
        />
      </Row>
    </>
  )
}
